/**
 * Formats string to valid selector (for CSS, element ids etc)
 * @param selectorString unformatted string
 * @returns formatted string, invalid chars removed
 */
export function formatSelector(selectorString: string) {
  // Remove spaces, periods, and commas
  return selectorString.replace(/[^a-zA-Z0-9_-]/g, '')
}
